module.exports = __webpack_public_path__ + "media/images/new-task-icon-d391b0f2.png";